import { ref, readonly } from 'vue';

export enum AppEvents {
	APP_RUN = 'APP_RUN',
	APP_DISABLE = 'APP_DISABLE',
	APP_ENABLE = 'APP_ENABLE',
	APP_UI_OVERLAP = 'APP_UI_OVERLAP' //active (true, false) -stop server
}

export const INTERNAL_EVENTS = {
	CONFIRM_PLAYER_WIN: 'confirm_player_win'
};

// Individual readonly refs for each status
const _isLoaded = ref(false);
export const isLoaded = readonly(ref(_isLoaded));

const _isActive = ref(false);
export const isActive = ref(_isActive);

const _isEnabled = ref(false);
export const isEnabled = ref(_isEnabled);

const _newActiveCampaign = ref(false);
export const newActiveCampaign = ref(_newActiveCampaign);

const _isUiOverlapped = ref(false);
export const isUiOverlapped = readonly(ref(_isUiOverlapped));

// Individual setters for each status
export const setLoaded = (value: boolean) => {
	_isLoaded.value = value;
};

//it is visible
export const setActive = (value: boolean) => {
	_isActive.value = value;
};

export const setEnabled = (value: boolean) => {
	_isEnabled.value = value;
};

export const setUiOverlapped = (value: boolean) => {
	_isUiOverlapped.value = value;
};

// export const setNewActiveCampaign = (value: boolean) => {
// 	_newActiveCampaign.value = value;
// };

// Update method with type safety
